import React, { Component } from 'react';
import ErrorMessage from '../common/ErrorMessage';
import SuccessMessage from '../common/SuccessMessage';
import Paper from '@material-ui/core/Paper';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Input from '@material-ui/core/Input';
import FormHelperText from '@material-ui/core/FormHelperText';
import Button from '@material-ui/core/Button';
import poweredLogo from '../../img/powered-by-logo.png';
import CircularProgress from '@material-ui/core/CircularProgress';
import * as MsalBrowser from '@azure/msal-browser';
import * as Msal from 'msal';
import Api, { ResponseError } from '@defi/core-api';
import { API_ROOT, GET_SSO_CONFIG, PROCESS_SSO } from '../../utils/apiRoutes';
import { PATH_ROOT } from '../../paths';
import Url from "../../utils/url";

const styles = {
  main: {
    maxWidth: '400px',
    minWidth: '250px',
  },
  paper: {
    padding: '60px 30px',
  },
  header: {
    paddingBottom: '20px',
  },
  button: {
    margin: '20px 0 10px',
  },
  bottom: {
    marginTop: '20px',
  },
  error: {
    color: '#fff',
    fontSize: '14px',
    backgroundColor: '#f44336',
    padding: '1px',
    marginTop: '10px',
    marginBottom: '15px',
  },
  center: {
    paddingTop: '150px',
  },
  h2: {
    borderBottom: '0px solid white',
    paddingBottom: 0,
  },
  h3: {
    paddingBottom: '15px',
  }
};

class Login extends Component {

  constructor(props) {
    super(props);

    this.ssoLoginRequest = props.ssoLoginRequest;
    this.state = { showLoading: true, message: "Loading..." };
    this.token = '';
    this.accountObj = null;
    this.authCodeFlowEnabled = false;
  }

    preventIframe() {
      if (window !== window.top) {
          window.top.location = window.location;
      }
  }
    async componentDidMount() {
    this.preventIframe();
    let ssoConfig = await this.getSsoConfig(false);
    let isDefiLogin = window.location.pathname.includes('defilogin');

    if (isDefiLogin) {
      if (ssoConfig.defiLoginDisabled) {
        window.localStorage.setItem("DefiUserLogin", false);
        this.props.history.push(PATH_ROOT);
        return;
      }

      ssoConfig = await this.getSsoConfig(true);
    }

    window.localStorage.setItem("DefiUserLogin", isDefiLogin);

    if (!ssoConfig.enabled) {
      this.setState({ showLoading: false });
      window.localStorage.setItem("SsoLoggedIn", false);
      return;
    }

    this.authCodeFlowEnabled = ssoConfig.authCodeFlowEnabled !== null && ssoConfig.authCodeFlowEnabled !== undefined ? ssoConfig.authCodeFlowEnabled : false;
    localStorage.setItem("SsoAuthFlowEnabled", this.authCodeFlowEnabled);
    var ssoEnabled = ssoConfig.enabled !== null && ssoConfig.enabled !== undefined ? ssoConfig.enabled : false;
    localStorage.setItem("SsoEnabled", ssoEnabled);

    this.setState({ hideLoginForm: true });
    window.localStorage.setItem("SsoLoggedIn", true);

    try {
      Url.storeRedirectUrl();
      let knownAuth = new URL(ssoConfig.ssoPolicy).host;

      localStorage.setItem("sso-aId", ssoConfig.applicationId);
      localStorage.setItem("sso-aut", ssoConfig.ssoPolicy);
      localStorage.setItem("SsoRoleMappingEnabled", ssoConfig.roleMappingEnabled);
      if (this.authCodeFlowEnabled) {
        localStorage.setItem("sso-known-auth", knownAuth);
      }

      let redirectLocation = Url.getMsalRedirect();
      var msalConfig = {
        auth: {
          clientId: ssoConfig.applicationId,
          authority: ssoConfig.ssoPolicy,
          validateAuthority: false,
          redirectUri: redirectLocation
        },
        cache: {
          cacheLocation: "localStorage",
          storeAuthStateInCookie: true
        }
      };
      if (this.authCodeFlowEnabled) {
        msalConfig.auth.knownAuthorities = [knownAuth]
        this.userAgentApplication = new MsalBrowser.PublicClientApplication(msalConfig)
      } else {
        this.userAgentApplication = new Msal.UserAgentApplication(msalConfig)
      }

      await this.loginWithSso(ssoConfig);
    } catch (err) {
      console.log(err);
      this.setState({ showLoading: false });
    }
  }

  renderLoading() {
    return (
      <div>
        <h2 className={styles.center}>{this.state.message}</h2>
        <CircularProgress
          size={75}
          thickness={3}
          style={{ color: '#334058' }}
        />
      </div>
    );
  }

  wait(ms) {
    var start = new Date().getTime();
    var end = start;
    while (end < start + ms) {
      end = new Date().getTime();
    }
  }

  async loginWithSso(ssoConfig) {

    let that = this;
    if (that.authCodeFlowEnabled) {
      try {
        var tokenResponse = await this.userAgentApplication.handleRedirectPromise();
        if (tokenResponse != null) this.accountObj = tokenResponse.account;
      } catch (error) {
        console.log("error passed to redirect callback " + error);
        localStorage.setItem('sso-error', error);
        if (error instanceof MsalBrowser.ClientAuthError || error instanceof MsalBrowser.ClientConfigurationError) {
          window.location.reload();
        }
      }
    } else {
      this.userAgentApplication.handleRedirectCallback(async (error, response) => {
        if (error) {
          console.log("error passed to redirect callback " + error);
          localStorage.setItem('sso-error', error);
          if (error instanceof Msal.ClientAuthError || error instanceof Msal.ClientConfigurationError) {
            window.location.reload();
          }
        } else {
          await that.getSsoToken({ scopes: ssoConfig.b2cScopes }, ssoConfig);
        }
      });

      if (this.userAgentApplication.isCallback(window.location.hash)) {
        return;
      }
    }


    if (localStorage.getItem('sso-error') !== null) {
      console.log(localStorage.getItem('sso-error'));
      localStorage.removeItem('sso-error');
      this.setState({ showLoading: false });
      that.ssoLoginRequest({ success: false, message: "Unable to login using SSO. Please contact administrator." });
      return;
    }

    setTimeout(async function () {
      var hasValidAccount = false;
      if (that.authCodeFlowEnabled) {
        const currentAccounts = await that.userAgentApplication.getAllAccounts();
        hasValidAccount = currentAccounts !== null && currentAccounts !== undefined && currentAccounts.length > 0;
      } else {
        hasValidAccount = that.userAgentApplication.getAccount();
      }

      if (!hasValidAccount) {
        await that.userAgentApplication.loginRedirect({ scopes: ssoConfig.b2cScopes, forceRefresh: false });
      } else {
        await that.getSsoToken({ scopes: ssoConfig.b2cScopes }, ssoConfig);
      }
    }, 1000);
  }

  async getSsoToken(tokenRequest, ssoConfig) {
    let tokenResponse = {};
    let that = this;
    if (that.authCodeFlowEnabled && this.accountObj != null) tokenRequest.account = this.accountObj;

    try {
      try {
        tokenResponse = await this.userAgentApplication.acquireTokenSilent(tokenRequest);
        console.log("acquireTokenSilent called");
      } catch (error) {
        console.log("acquireTokenSilent unsuccessful", error.errorMessage);
        tokenResponse = await this.userAgentApplication.acquireTokenRedirect(tokenRequest);
        console.log("acquireTokenRedirect called");
      }

      try {
        var accessToken = that.authCodeFlowEnabled && tokenResponse.accessToken === "" && tokenResponse.idToken !== undefined && tokenResponse.idToken !== null
          ? tokenResponse.idToken
          : tokenResponse.accessToken;
        var response = await this.processSsoToken(accessToken, ssoConfig);
        console.log("sso token processed")

        that.ssoLoginRequest({ success: true, response });
      } catch (error) {
        console.log("error processing sso token", error);

        if (error instanceof ResponseError) {
          if (error.statusCode === 403) {
            throw error.message;
          }
        }

        var message = "Unable to login using SSO. Please contact administrator.";
        throw message;
      }
    } catch (error) {
      console.log("error getting sso token");
      console.log(error);

      that.ssoLoginRequest({ success: false, message: error });
      this.setState({ showLoading: false });
    }
  }

  async getSsoConfig(isPrivilegedUser) {
    let result = [];

    let data = {
      clientUrl: window.location.hostname,
      isPrivilegedUser: isPrivilegedUser
    };

    try {
      var response = await Api.post(API_ROOT, GET_SSO_CONFIG, data, false, null);
      if (response.Success) {
        result = JSON.parse(response.Value);
      }
    } catch (err) {
      console.log(err);
    }

    return result.length > 0 ? result[0] : { enabled : false, defiLoginDisabled : true };
  }

  async processSsoToken(accessToken, ssoConfig) {
    console.log("accessToken", accessToken);

    let data = {
      token: accessToken,
      applicationId: ssoConfig.applicationId,
      ssoPolicy: ssoConfig.ssoPolicy,
      ssoPriority: 1,
      ssoRoleMappingEnabled: ssoConfig.roleMappingEnabled,
      clientUrl: window.location.hostname,
      isPrivilegedUser: window.location.pathname.includes('defilogin')
    };

    return await Api.post(API_ROOT, PROCESS_SSO, data, false, null);
  }

  render() {
    const {
      error,
      success,
      currentlySending,
      loading,
      username,
      errorUsername,
      password,
      errorPassword,
      handleSubmit,
      handlePasswordChange,
      handleUsernameChange,
      logo,
      contactText
    } = this.props;

    return (
      <div className="col-xs-10 col-sm-6 col-md-4 col-lg-4" style={styles.main}>
        <div className="box">
          <Paper elevation={3} style={styles.paper}>
            {this.state.showLoading && <center className={styles.center}>{this.renderLoading()}</center>}
            {!this.state.showLoading && <form action="#" method="POST" onSubmit={handleSubmit}>
              <div className="row center-xs">
                <div className="col-xs-12">
                  <div className="box">{logo()}</div>
                </div>
                <div className="col-xs-12">
                  <div className="box">
                    {currentlySending || loading ? (
                      <CircularProgress size={25} thickness={5} />
                    ) : (
                        [
                          <SuccessMessage message={success} key={0} />,
                          <ErrorMessage error={error} key={1} />,
                        ]
                      )}
                  </div>
                </div>

                {!this.state.hideLoginForm && <div>
                  <div className="col-sm-10 col-xs-11">
                    <div className="box" style={{ margin: '10px 0 10px' }}>
                      <FormControl
                        fullWidth
                        error={errorUsername ? true : false}
                        aria-describedby="username"
                      >
                        <InputLabel shrink htmlFor="username-label">
                          Username
                      </InputLabel>
                        <Input
                          autoComplete="off"
                          id="username"
                          disabled={currentlySending}
                          value={username}
                          onChange={handleUsernameChange}
                        />
                        <FormHelperText id="username-error-text">{errorUsername}</FormHelperText>
                      </FormControl>
                    </div>
                  </div>
                  <div className="col-sm-10 col-xs-11">
                    <div className="box">
                      <FormControl
                        fullWidth
                        error={errorUsername ? true : false}
                        aria-describedby="password"
                      >
                        <InputLabel shrink htmlFor="password-label">
                          Password
                      </InputLabel>
                        <Input
                          autoComplete="off"
                          id="password"
                          disabled={currentlySending}
                          value={password}
                          onChange={handlePasswordChange}
                          type="password"
                        />
                        <FormHelperText id="password-error-text">{errorPassword}</FormHelperText>
                      </FormControl>
                    </div>
                  </div>
                  <div className="col-xs-12">
                    <div className="box">
                      <div />
                      <Button
                        variant="contained"
                        id="submit-button"
                        type="submit"
                        style={styles.button}
                        className="submitButton"
                        color="primary"
                        disabled={currentlySending || (success && success.length > 0) ? true : false}
                      >
                        Login
                    </Button>
                    </div>
                  </div>
                </div>}
                <div className="col-xs-8">
                  <div className="box">
                    {contactText()}
                  </div>
                </div>
              </div>
            </form>}
          </Paper>
          <a href="http://defisolutions.com" target="_blank" rel="noopener noreferrer">
            <img src={poweredLogo} style={styles.bottom} alt="logo" />
          </a>
        </div>
      </div>
    );
  }
}

export default Login;
